import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantsStore from '../../../../ParticipantsStore';
import { ParticipantsOptionsResource } from '../../../../ParticipantsStore/Options/Types';
import GeneralFilters from '../GeneralFilters';
import LimaFilters from '../LimaFilters';

interface Props {
  participantsStore: ParticipantsStore;
  licenseFamily: LicenseFamily;
  participantsOptionsResource: ParticipantsOptionsResource;
}

function Filters({ participantsStore, licenseFamily, participantsOptionsResource }: Props) {
  return (
    <div className="flex flex-col py-5 md:flex-row ">
      <GeneralFilters
        participantsOptionsResource={participantsOptionsResource}
        participantsStore={participantsStore}
        selectedOrganization={participantsStore.selectedOrganization}
      />
      <LimaFilters
        licenseFamily={licenseFamily}
        searchParameters={participantsStore.searchParameters}
        updatingSearchParameters={participantsStore.updatingSearchParameters}
        participantsOptionsResource={participantsOptionsResource}
      />
    </div>
  );
}
export default observer(Filters);
